import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from '@/lib/api/auth'
import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
} from '@/components/ui/credenza'
import PositionForm from '@/components/forms/position-form'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/user-role-management/position/add',
)({
  beforeLoad: async () => {
    validateUserAddPermission()
  },
  component: AddPositionPage,
})

export default function AddPositionPage() {
  const [showAddPositionPage, setShowAddPositionPage] = useState(false)
  return (
    <main className="space-y-4">
      <Button
        onClick={() => {
          setShowAddPositionPage(true)
        }}
      >
        <Icons.add className="size-4" />
        Add Position
      </Button>
      <Credenza
        open={showAddPositionPage}
        onOpenChange={setShowAddPositionPage}
      >
        <CredenzaContent className="w-full max-w-xl justify-center">
          <CredenzaBody>
            <PositionForm setShowAddPositionPage={setShowAddPositionPage} />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
